import jwtAxios from "../../util/jwtUtil";

const apiHost = process.env.REACT_APP_API_HOST;

/**
 * 접근 가능 계열사 목록 조회
 * @returns {Promise} 계열사 목록 응답
 */
export const apiAccessibleTenantsGet = async () => {
  const url = `${apiHost}/api/group/accessible-tenants`;

  try {
    const res = await jwtAxios.get(url, {
      withCredentials: false,
    });
    return res.data;
  } catch (error) {
    console.error("API 요청 에러:", error.response?.data || error.message);
    throw error;
  }
};

/**
 * 계열사 전환 (새 JWT 발급)
 * @param {string} targetTenantId - 전환할 대상 테넌트 ID
 * @returns {Promise} 새 JWT 토큰 응답
 */
export const apiSwitchTenantPost = async (targetTenantId) => {
  const url = `${apiHost}/api/group/switch-tenant`;

  try {
    const res = await jwtAxios.post(
      url,
      { targetTenantId },
      {
        withCredentials: true, // refresh token 쿠키 전송/갱신을 위해 필수
        headers: { "Content-Type": "application/json" },
      }
    );
    return res.data;
  } catch (error) {
    console.error("API 요청 에러:", error.response?.data || error.message);
    throw error;
  }
};
